import { Stack, useLocalSearchParams } from "expo-router";
// @ts-expect-error baseline 2026-06-02
import { WebLayout } from "@src/components/web";
import { VehicleSearchScreen } from "@src/features/vehicles/screens/VehicleSearchScreen";

export default function TenantVehiclesScreen() {
  const { siteIds } = useLocalSearchParams<{ tenantId: string; siteIds?: string }>();
  return (
    <>
      <Stack.Screen options={{ headerShown: false }} />
      <WebLayout>
        <VehicleSearchScreen siteIdFromRoute={siteIds ?? null} showPageHeader />
      </WebLayout>
    </>
  );
}
